
// src/web/components/alert-message.jsx

import React from 'react'
import connect from '../../connects/alert-message'
import { CSSTransition } from 'react-transition-group';
import {
  Snackbar,
} from 'react-toolbox/lib/snackbar'
import FontIcon from 'react-toolbox/lib/font_icon'
import _ from 'lodash'
import SnackbarTheme from './themes/snackbar.css'
import SuccessIcon from '../../assets/stamps/gamba-kun-yattaze.png'


function ToastContent(props){
  const {
    message,
    type,
  } = props

  switch(type){
    case 'success':
    return (
      <div className="check_circle">
        <FontIcon value='check_circle'/>
      {message}
    </div>
    )
    case 'postSuccess':
      return (
      <div className="toast_Content">
        <img src={SuccessIcon} className="toastImg" />
        {message}
      </div>
      )
    case 'messageAlert':
      return (                                                                                                                                          
      <div className="toast_Content">
        <FontIcon value='comment' style={{paddingRight: '10px'}}/>
        {message}
      </div>
      )
    case 'error':
      return (
        <div className="error_info">
          <FontIcon value='cancel'/>
          {message}
        </div>
      )
    default:
      return null
  }

}

class AlertMessage extends React.Component {
  clearAlertMessage = () => {
    this.props.fadeOutAlertMessage(this.props)
    setTimeout(() => this.props.clearAlertMessage(this.props), 500)
  }

  render() {
    const {
      t,
      ui,
      i18n,
      category,
    } = this.props

    if (!this.props.message || this.props.message.length == 0)
      return null

    const message = 
        (_.isArray(this.props.message) ? this.props.message : [this.props.message])
        .map((msg)=> {
          if (_.isObject(msg) && _.isString(msg.message) && i18n.exists(msg.message))
            return t(msg.message, msg)
          else if (_.isString(msg) && i18n.exists(msg))
            return t(msg)
          else if (_.isString(msg))
            return msg
          else
            return ''
        }).join(' ')

    const toastList = [
      { category: 'success', type: 'success', className: 'successToastify'   },
      { category: 'inputSuccess', type: 'success', className: 'successToastify' },
      { category: 'postSuccess', type: 'postSuccess', className: 'successToastify' },
      { category: 'messageAlert', type: 'messageAlert', className: 'successToastify' },
      { category: 'topSuccess', type: 'success', className: 'successToastify' },
      { category: 'error', type: 'error', className: 'errorToastify' },
    ]

    const toastType= category => {
      const type = toastList.find(t => t.category === category).type
      return type
    }

    const toastClassName= category => {
      const type = toastList.find(t => t.category === category).className
      return type
    }

    if (message && message.length > 0)
      return (
        <Snackbar
          label={<ToastContent message={message} type={toastType(this.props.category)}/>}
          active={ui.onAlert}
          timeout={toastType(this.props.category) != 'error' && 3000 || 100000}
          onTimeout={this.clearAlertMessage}
          type={toastType(this.props.category) == 'error' && 'warning' || 'accept'}
          action={<div className="closeIcon"><FontIcon value='close'/></div>}
          onClick={this.clearAlertMessage} 
          className={toastClassName(this.props.category)}
          theme={SnackbarTheme}/>
      )
    else 
      return null
  }
}
export const RawAlertMessage = AlertMessage
export default connect(AlertMessage)



// WEBPACK FOOTER //
// ./src/web/components/alert-message.jsx